<!-- 柱状图 -->
<style lang="stylus" scoped>
.bar-wrap
  width 100%
  height 354px
  padding 18px 0
  display flex
  flex-wrap wrap
  img
    width 136px
    height 106px
    margin-right 10px
    margin-bottom 5px


</style>

<template>
  <boxWrap :name="name">
    <div class="bar-wrap">
      <img src="../../../../static/img/trace/1.png" alt="">
      <img src="../../../../static/img/trace/2.png" alt="">
      <img src="../../../../static/img/trace/3.png" alt="">
      <img src="../../../../static/img/trace/4.png" alt="">
      <img src="../../../../static/img/trace/5.png" alt="">
      <img src="../../../../static/img/trace/6.png" alt="">
      <img src="../../../../static/img/trace/7.png" alt="">
      <img src="../../../../static/img/trace/8.png" alt="">
      <img src="../../../../static/img/trace/9.png" alt="">
    </div>
  </boxWrap>
</template>

<script>
import echarts from 'echarts'
import boxWrap from 'components/dashboard/common/boxWrap';
export default {
  data() {
    return {
      name: '可追溯商品（18个）'
    }
  },
  components: {
    boxWrap
  },
  methods: {
  },
  mounted() {
  }
}

</script>



// WEBPACK FOOTER //
// index.vue?8c27727e